import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { aLink } from '@src/utils/common-util';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { $$tracker } from '@src/tracker';
import cmsApi from '@src/services/cms-api';
const lang = getLanguageByPath();

class CreatorsSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  @observable isActive = false;

  @observable creatorProgramLink = `https://mechabreak.seasungames.com/creator_program/${lang}/`;
  // @observable en_creatorProgramLink = 'https://creators.gamesight.io/programs/mecha-break';

  @observable JOIN_NOW;

  clickGame = () => {
    // 招募页面
    // if (this.creatorProgramLink) {
    //   aLink(this.creatorProgramLink);
    // }

    // 问卷
    if (this.JOIN_NOW) {
      aLink(this.JOIN_NOW);
    }

    $$tracker.clickCzz();
  };

  /**
   *  获取多语言外部表单
   *  https://www.mechabreak.com/api/config/tag/zt/mechabreak_creator_program?filter=0
   * @returns
   */
  programConfig = async () => {
    return await cmsApi
      .makeCmsCustomConfigRequest('//www.mechabreak.com/api/config/tag/', 'zt/mechabreak_creator_program')
      .then(res => {
        let propName = getLanguageByPath() === 'zh-Hant' ? 'tc_link' : getLanguageByPath() + '_link';
        this.JOIN_NOW = res[propName];
        // 8月Beta版注册链接`
        // this.Aug_Beta_Enrollment = res?.en_questionnaire;
      })
      .catch(e => {
        console.log(e);
      });
  };

  use() {
    useMount(() => {
      this.programConfig();
    });
  }
}

export default CreatorsSectionStore;
